require('./navigation');
require('./map');
require('./lang-switch');